import { g as J } from "../_commonjsHelpers-DaMA6jEr.mjs";
var q = {}, W = {}, R = {};
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = void 0;
  var h = function() {
    for (var b = arguments.length, A = new Array(b), w = 0; w < b; w++)
      A[w] = arguments[w];
    if (typeof window < "u") {
      var o;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (o = window).gtag.apply(o, A);
    }
  }, v = h;
  g.default = v;
})(R);
var F = {};
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = w;
  var h = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function v(o) {
    return o.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(u, c, l) {
      return c > 0 && c + u.length !== l.length && u.search(h) > -1 && l.charAt(c - 2) !== ":" && (l.charAt(c + u.length) !== "-" || l.charAt(c - 1) === "-") && l.charAt(c - 1).search(/[^\s-]/) < 0 ? u.toLowerCase() : u.substr(1).search(/[A-Z]|\../) > -1 ? u : u.charAt(0).toUpperCase() + u.substr(1);
    });
  }
  function S(o) {
    return typeof o == "string" && o.indexOf("@") !== -1;
  }
  var b = "REDACTED (Potential Email Address)";
  function A(o) {
    return S(o) ? (console.warn("This arg looks like an email address, redacting."), b) : o;
  }
  function w() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, l = o || "";
    return u && (l = v(o)), c && (l = A(l)), l;
  }
})(F);
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = g.GA4 = void 0;
  var h = w(R), v = w(F), S = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], b = ["title", "location"], A = ["page", "hitType"];
  function w(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, e) {
    if (a == null) return {};
    var t = u(a, e), n, r;
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(a);
      for (r = 0; r < i.length; r++)
        n = i[r], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(a, n) && (t[n] = a[n]);
    }
    return t;
  }
  function u(a, e) {
    if (a == null) return {};
    var t = {}, n = Object.keys(a), r, i;
    for (i = 0; i < n.length; i++)
      r = n[i], !(e.indexOf(r) >= 0) && (t[r] = a[r]);
    return t;
  }
  function c(a) {
    "@babel/helpers - typeof";
    return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, c(a);
  }
  function l(a) {
    return P(a) || O(a) || T(a) || C();
  }
  function C() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function O(a) {
    if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
  }
  function P(a) {
    if (Array.isArray(a)) return G(a);
  }
  function E(a, e) {
    var t = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(a);
      e && (n = n.filter(function(r) {
        return Object.getOwnPropertyDescriptor(a, r).enumerable;
      })), t.push.apply(t, n);
    }
    return t;
  }
  function _(a) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e] != null ? arguments[e] : {};
      e % 2 ? E(Object(t), !0).forEach(function(n) {
        d(a, n, t[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : E(Object(t)).forEach(function(n) {
        Object.defineProperty(a, n, Object.getOwnPropertyDescriptor(t, n));
      });
    }
    return a;
  }
  function Q(a, e) {
    return V(a) || k(a, e) || T(a, e) || U();
  }
  function U() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function T(a, e) {
    if (a) {
      if (typeof a == "string") return G(a, e);
      var t = Object.prototype.toString.call(a).slice(8, -1);
      if (t === "Object" && a.constructor && (t = a.constructor.name), t === "Map" || t === "Set") return Array.from(a);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return G(a, e);
    }
  }
  function G(a, e) {
    (e == null || e > a.length) && (e = a.length);
    for (var t = 0, n = new Array(e); t < e; t++) n[t] = a[t];
    return n;
  }
  function k(a, e) {
    var t = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
    if (t != null) {
      var n, r, i, f, s = [], p = !0, m = !1;
      try {
        if (i = (t = t.call(a)).next, e !== 0) for (; !(p = (n = i.call(t)).done) && (s.push(n.value), s.length !== e); p = !0) ;
      } catch (y) {
        m = !0, r = y;
      } finally {
        try {
          if (!p && t.return != null && (f = t.return(), Object(f) !== f)) return;
        } finally {
          if (m) throw r;
        }
      }
      return s;
    }
  }
  function V(a) {
    if (Array.isArray(a)) return a;
  }
  function B(a, e) {
    if (!(a instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function H(a, e) {
    for (var t = 0; t < e.length; t++) {
      var n = e[t];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(a, M(n.key), n);
    }
  }
  function K(a, e, t) {
    return e && H(a.prototype, e), Object.defineProperty(a, "prototype", { writable: !1 }), a;
  }
  function d(a, e, t) {
    return e = M(e), e in a ? Object.defineProperty(a, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : a[e] = t, a;
  }
  function M(a) {
    var e = Z(a, "string");
    return c(e) === "symbol" ? e : String(e);
  }
  function Z(a, e) {
    if (c(a) !== "object" || a === null) return a;
    var t = a[Symbol.toPrimitive];
    if (t !== void 0) {
      var n = t.call(a, e || "default");
      if (c(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(a);
  }
  var L = /* @__PURE__ */ function() {
    function a() {
      var e = this;
      B(this, a), d(this, "reset", function() {
        e.isInitialized = !1, e._testMode = !1, e._currentMeasurementId, e._hasLoadedGA = !1, e._isQueuing = !1, e._queueGtag = [];
      }), d(this, "_gtag", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        e._testMode || e._isQueuing ? e._queueGtag.push(n) : h.default.apply(void 0, n);
      }), d(this, "_loadGA", function(t, n) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !e._hasLoadedGA) {
          var i = document.createElement("script");
          i.async = !0, i.src = "".concat(r, "?id=").concat(t), n && i.setAttribute("nonce", n), document.body.appendChild(i), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, e._hasLoadedGA = !0;
        }
      }), d(this, "_toGtagOptions", function(t) {
        if (t) {
          var n = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, r = Object.entries(t).reduce(function(i, f) {
            var s = Q(f, 2), p = s[0], m = s[1];
            return n[p] ? i[n[p]] = m : i[p] = m, i;
          }, {});
          return r;
        }
      }), d(this, "initialize", function(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!t)
          throw new Error("Require GA_MEASUREMENT_ID");
        var r = typeof t == "string" ? [{
          trackingId: t
        }] : t;
        e._currentMeasurementId = r[0].trackingId;
        var i = n.gaOptions, f = n.gtagOptions, s = n.nonce, p = n.testMode, m = p === void 0 ? !1 : p, y = n.gtagUrl;
        if (e._testMode = m, m || e._loadGA(e._currentMeasurementId, s, y), e.isInitialized || (e._gtag("js", /* @__PURE__ */ new Date()), r.forEach(function(I) {
          var j = _(_(_({}, e._toGtagOptions(_(_({}, i), I.gaOptions))), f), I.gtagOptions);
          Object.keys(j).length ? e._gtag("config", I.trackingId, j) : e._gtag("config", I.trackingId);
        })), e.isInitialized = !0, !m) {
          var z = l(e._queueGtag);
          for (e._queueGtag = [], e._isQueuing = !1; z.length; ) {
            var D = z.shift();
            e._gtag.apply(e, l(D)), D[0] === "get" && (e._isQueuing = !0);
          }
        }
      }), d(this, "set", function(t) {
        if (!t) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (c(t) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(t).length === 0 && console.warn("empty `fieldsObject` given to .set()"), e._gaCommand("set", t);
      }), d(this, "_gaCommandSendEvent", function(t, n, r, i, f) {
        e._gtag("event", n, _(_({
          event_category: t,
          event_label: r,
          value: i
        }, f && {
          non_interaction: f.nonInteraction
        }), e._toGtagOptions(f)));
      }), d(this, "_gaCommandSendEventParameters", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        if (typeof n[0] == "string")
          e._gaCommandSendEvent.apply(e, l(n.slice(1)));
        else {
          var i = n[0], f = i.eventCategory, s = i.eventAction, p = i.eventLabel, m = i.eventValue;
          i.hitType;
          var y = o(i, S);
          e._gaCommandSendEvent(f, s, p, m, y);
        }
      }), d(this, "_gaCommandSendTiming", function(t, n, r, i) {
        e._gtag("event", "timing_complete", {
          name: n,
          value: r,
          event_category: t,
          event_label: i
        });
      }), d(this, "_gaCommandSendPageview", function(t, n) {
        if (n && Object.keys(n).length) {
          var r = e._toGtagOptions(n), i = r.title, f = r.location, s = o(r, b);
          e._gtag("event", "page_view", _(_(_(_({}, t && {
            page_path: t
          }), i && {
            page_title: i
          }), f && {
            page_location: f
          }), s));
        } else t ? e._gtag("event", "page_view", {
          page_path: t
        }) : e._gtag("event", "page_view");
      }), d(this, "_gaCommandSendPageviewParameters", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        if (typeof n[0] == "string")
          e._gaCommandSendPageview.apply(e, l(n.slice(1)));
        else {
          var i = n[0], f = i.page;
          i.hitType;
          var s = o(i, A);
          e._gaCommandSendPageview(f, s);
        }
      }), d(this, "_gaCommandSend", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        var i = typeof n[0] == "string" ? n[0] : n[0].hitType;
        switch (i) {
          case "event":
            e._gaCommandSendEventParameters.apply(e, n);
            break;
          case "pageview":
            e._gaCommandSendPageviewParameters.apply(e, n);
            break;
          case "timing":
            e._gaCommandSendTiming.apply(e, l(n.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(i));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(i));
        }
      }), d(this, "_gaCommandSet", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        typeof n[0] == "string" && (n[0] = d({}, n[0], n[1])), e._gtag("set", e._toGtagOptions(n[0]));
      }), d(this, "_gaCommand", function(t) {
        for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
          r[i - 1] = arguments[i];
        switch (t) {
          case "send":
            e._gaCommandSend.apply(e, r);
            break;
          case "set":
            e._gaCommandSet.apply(e, r);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(t));
        }
      }), d(this, "ga", function() {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        if (typeof n[0] == "string")
          e._gaCommand.apply(e, n);
        else {
          var i = n[0];
          e._gtag("get", e._currentMeasurementId, "client_id", function(f) {
            e._isQueuing = !1;
            var s = e._queueGtag;
            for (i({
              get: function(y) {
                return y === "clientId" ? f : y === "trackingId" ? e._currentMeasurementId : y === "apiVersion" ? "1" : void 0;
              }
            }); s.length; ) {
              var p = s.shift();
              e._gtag.apply(e, l(p));
            }
          }), e._isQueuing = !0;
        }
        return e.ga;
      }), d(this, "event", function(t, n) {
        if (typeof t == "string")
          e._gtag("event", t, e._toGtagOptions(n));
        else {
          var r = t.action, i = t.category, f = t.label, s = t.value, p = t.nonInteraction, m = t.transport;
          if (!i || !r) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var y = {
            hitType: "event",
            eventCategory: (0, v.default)(i),
            eventAction: (0, v.default)(r)
          };
          f && (y.eventLabel = (0, v.default)(f)), typeof s < "u" && (typeof s != "number" ? console.warn("Expected `args.value` arg to be a Number.") : y.eventValue = s), typeof p < "u" && (typeof p != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : y.nonInteraction = p), typeof m < "u" && (typeof m != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(m) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), y.transport = m)), e._gaCommand("send", y);
        }
      }), d(this, "send", function(t) {
        e._gaCommand("send", t);
      }), this.reset();
    }
    return K(a, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), a;
  }();
  g.GA4 = L;
  var x = new L();
  g.default = x;
})(W);
(function(g) {
  function h(o) {
    "@babel/helpers - typeof";
    return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, h(o);
  }
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = g.ReactGAImplementation = void 0;
  var v = b(W);
  function S(o) {
    if (typeof WeakMap != "function") return null;
    var u = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (S = function(C) {
      return C ? c : u;
    })(o);
  }
  function b(o, u) {
    if (o && o.__esModule)
      return o;
    if (o === null || h(o) !== "object" && typeof o != "function")
      return { default: o };
    var c = S(u);
    if (c && c.has(o))
      return c.get(o);
    var l = {}, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var O in o)
      if (O !== "default" && Object.prototype.hasOwnProperty.call(o, O)) {
        var P = C ? Object.getOwnPropertyDescriptor(o, O) : null;
        P && (P.get || P.set) ? Object.defineProperty(l, O, P) : l[O] = o[O];
      }
    return l.default = o, c && c.set(o, l), l;
  }
  var A = v.GA4;
  g.ReactGAImplementation = A;
  var w = v.default;
  g.default = w;
})(q);
const X = /* @__PURE__ */ J(q), N = (g, h = "local", v) => {
  if (!v) {
    console.warn("GA_MEASUREMENT_ID is not set. Google Analytics will not be initialized.");
    return;
  }
  h === "staging" || h === "production" ? X.initialize(v, {
    // Use gaOptions to send custom dimensions with every GA event except initial_page_view.
    // gtagOptions could be used to send custom dimensions to initial_page_view only, if desired.
    gaOptions: {
      // custom dimensions to report
      scripps_brand: g,
      scripps_platform: "Web"
    }
  }) : console.info("** Note: Google Analytics is only initialized in staging and production environments. **");
};
export {
  N as initializeAnalytics
};
